"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CardBody", {
    enumerable: true,
    get: function() {
        return CardBody;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const CardBody = (param)=>{
    let { children, ...props } = param;
    const { spacers } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ...props,
        className: _style.default.dynamic([
            [
                "a10af6deb021a913",
                [
                    spacers.s3
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "a10af6deb021a913",
        dynamic: [
            spacers.s3
        ]
    }, "div.__jsx-style-dynamic-selector{padding:".concat(spacers.s3, "}")));
};

//# sourceMappingURL=CardBody.js.map